export default "__VITE_ASSET__Dehqsv02__"